// Quick Add Transitions - Helper script
document.addEventListener('DOMContentLoaded', function() {
  // Add a class to body once JS is loaded to enable transitions
  document.body.classList.add('js-quick-add-transitions-ready');
  
  // Helper function to reinitialize transition effects after content changes
  function initQuickAddTransitions() {
    // Get all quick-add elements, both in cards and product pages
    const quickAddElements = document.querySelectorAll('.quick-add');
    
    quickAddElements.forEach(quickAdd => {
      if (quickAdd) {
        const buttons = quickAdd.querySelectorAll('.quick-add__submit');
        buttons.forEach(button => {
          button.style.backgroundColor = '#E54821';
          button.style.color = '#ffffff';
          button.style.borderColor = '#E54821';
          
          // Add event listener to stop propagation for button clicks
          if (!button.hasAttribute('data-click-handler-added')) {
            button.setAttribute('data-click-handler-added', 'true');
            button.addEventListener('click', function(e) {
              e.stopPropagation();
              e.preventDefault();
              
              // If this button has a product URL, use it for modal or form submit
              const productUrl = button.getAttribute('data-product-url');
              if (productUrl) {
                // If it's a modal opener, find the modal-opener parent and simulate click
                const modalOpener = button.closest('modal-opener');
                if (modalOpener) {
                  // Do nothing here as the click event will reach the modal-opener
                } else {
                  // This is a direct add-to-cart button - find the form and submit it
                  const form = button.closest('form');
                  if (form) {
                    form.submit();
                  }
                }
              }
            });
          }
        });
        
        // Add event listener to stop propagation for the entire quick-add container
        if (!quickAdd.hasAttribute('data-click-handler-added')) {
          quickAdd.setAttribute('data-click-handler-added', 'true');
          quickAdd.addEventListener('click', function(e) {
            e.stopPropagation();
          });
          
          // Also prevent touch events from propagating on mobile
          quickAdd.addEventListener('touchstart', function(e) {
            e.stopPropagation();
          }, { passive: true });
          
          // Make the quick-add container have a higher z-index to ensure it's clickable
          quickAdd.style.zIndex = '10';
        }
      }
    });

    // Make sure product-form quick-adds remain visible
    const productFormQuickAdds = document.querySelectorAll('.product-form.quick-add');
    productFormQuickAdds.forEach(quickAdd => {
      quickAdd.style.opacity = '1';
      quickAdd.style.visibility = 'visible';
      quickAdd.style.transform = 'translateY(0)';
      quickAdd.style.pointerEvents = 'auto';
    });
    
    // Add mouseleave handlers to cards for smooth transition handling
    const cardWrappers = document.querySelectorAll('.card-wrapper');
    cardWrappers.forEach(card => {
      const quickAdd = card.querySelector('.quick-add');
      
      // Only add handler if we haven't already
      if (quickAdd && !card.hasAttribute('data-quick-add-handler')) {
        card.setAttribute('data-quick-add-handler', 'true');
        
        card.addEventListener('mouseleave', () => {
          // Force hide the quick-add element to ensure smooth transition
          if (quickAdd) {
            quickAdd.style.opacity = '0';
            quickAdd.style.visibility = 'hidden';
            quickAdd.style.transform = 'translateY(10px)';
            quickAdd.style.pointerEvents = 'none';
            // Reset after transition completes
            setTimeout(() => {
              quickAdd.style.removeProperty('opacity');
              quickAdd.style.removeProperty('visibility');
              quickAdd.style.removeProperty('transform');
              quickAdd.style.removeProperty('pointer-events');
            }, 300);
          }
        });
      }
    });
  }
  
  // Initialize on page load
  initQuickAddTransitions();
  
  // Reinitialize on section reload events
  document.addEventListener('shopify:section:load', initQuickAddTransitions);
  document.addEventListener('shopify:section:select', initQuickAddTransitions);
  document.addEventListener('shopify:section:render', initQuickAddTransitions);
  
  // Apply immediately when DOM content is loaded
  initQuickAddTransitions();
  
  // Re-apply after a short delay to catch any dynamically loaded content
  setTimeout(initQuickAddTransitions, 500);
  
  // For touch devices, we need special handling
  if (window.matchMedia('(hover: none)').matches) {
    // Touch device detected, apply special handling if needed
    document.body.classList.add('touch-device');
  }
});